<ul class="navbar-mobile" role="menu">
    @for (item of navItemList; track $index) {
        <li class="navbar-mobile__item" role="presentation">
            @if (item.path) {
                <a class="a--border-off text-nowrap a--black"
                   [routerLink]="item.path"
                   [attr.title]="item.title | translate"
                   role="menuitem">
                    @if (item?.icon) {
                        <mat-icon class="mb-1">{{ item.icon }}</mat-icon>
                    }
                    {{ item.title | translate }}
                </a>
            }
        </li>
    }
</ul>
